export const connectOpenDashboardQuickAction = {
  type: 'app',
  name: 'Dashboard',
  icon: {
    type: 'mdi',
    src: 'mdiLayersTripleOutline',
  },
  color: 'red',
  link: {
    type: 'external-link',
    to: '{baseUrl}/connect/dashboard/main?tenantId={tenantId}&organization={organizationId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: "$.baseUrl['#env#']",
          resource: '_self',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
    ],
  },
  baseUrl: {
    dev: 'https://connect-dev.sitecore-staging.cloud',
    qa: 'https://connect-qa.sitecore-staging.cloud',
    staging: 'https://connect-staging.sitecore-staging.cloud',
    'pre-production': 'https://connect-beta.sitecorecloud.io',
    production: 'https://connect.sitecorecloud.io',
  },
  displayName: {
    name: '{displayName}',
    replacements: [
      {
        key: 'displayName',
        source: {
          jsonPath: '$.displayName',
          resource: 'tenant',
        },
      },
    ],
  },
  category: 'Quick Actions',
};
